/**
 * Created by tdunham on 8/18/2017.
 */

export class League {


	public id:              number;     // The ID of the league in the Angular ReST API.
	public title:           string;     // The league name. ("American League or National League")
	public code:            string;     // The abbreviated sport name. ("MLB")


	constructor( values: Object = {} ) {
		Object.assign( this, values );
	}

}


// WEBPACK FOOTER //
// ./src/app/services/team/league.ts